// GLOBAL CONSTANTS
// -----------------------------------

export const APP_COLORS = {
  'primary': '#0C88E3',
  'success': '#4CAF50',
  'info': '#23b7e5',
  'warning': '#ff902b',
  'danger': '#f05050',
  'inverse': '#131e26',
  'green': '#37bc9b',
  'pink': '#f532e5',
  'purple': '#7266ba',
  'dark': '#3a3f51',
  'yellow': '#fad732',
  'gray-darker': '#232735',
  'gray-dark': '#3a3f51',
  'gray': '#dde6e9',
  'gray-light': '#e4eaec',
  'gray-lighter': '#edf1f2',
  'blue': '#56A0D3',
  'body-color': '#656565',
  'sub-category-nav': '#0D3B69',
  'category-nav': 'black',
  'active-category-background-nav': '#FFECB3',
};

export const APP_MEDIAQUERY = {
  'desktopLG': 1200,
  'desktop': 992,
  'tablet': 768,
  'mobile': 480,
};

export const UI_HEIGHT = {
  'leftBar': 235,
  'rightBar': 300,
  'binDetail': 210,
  'noButton': 295,
  'oneLineButton': 330,
  'twoLineButton': 380,
  'fourLineButton': 460,
  'fiveLineButton': 500,
  'inventoriesPage': 325,
  'customersPage': 255,
  'vendorsPage': 255,
  'editSalesInvPage': 320,
  'heightLess490': 490,
  'inventoryDetailPage': 700,
  'presidentDashboard': 180,
};

export const BACKGROUND_COLOR = {
  'red': '#C96059',
  'blue': '#309DBA',
  tintedPink: '#FFAFAF',
  tintedYellow: '#FFF9C4',
  tintedBlue: '#90CAF9',
  tintedRed: '#F44336',
  'yellow': '#E7AE5A',
  'gray': '#e8e8e8',
  'lightGray': '#A9A9A9',
  'OutofStock': '#7C0000',
  'InStock': '#237193',
  nonFixed: 'rgba(231, 174, 90, 0.4)',
  fixed: 'rgba(88, 88, 88, 0.4)',
};

export const DEFAULT_ERROR = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';



// WEBPACK FOOTER //
// ./master/jsx/components/Common/constants.js